/** Public CARTO basemap key (free raster/vector tier). Required on tile URLs. */
export const CARTO_BASEMAP_KEY = "cb1_27ot_1_d192e118e56c430d4712c8b2";

export function cartoTiles(style: string): string {
  return `https://{s}.basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png?key=${CARTO_BASEMAP_KEY}`;
}
